<template>
    <vue-scroll style="max-height: 300px">
        <div class="notification-box">
            <div class="notify" v-for="n in computedNotifications" :key="n.id">
                <div class="flex">
                    <div class="n-title box grow">
                        <strong>{{ n.title }}</strong>
                    </div>
                    <div class="n-date">
                        {{ n.date | relative }} <i class="mdi mdi-clock"></i>
                    </div>
                </div>
                <div class="n-desc" v-if="n.text">{{ n.text }}<br /></div>
                <div class="n-desc" v-if="n.lines">
                    <template v-for="(line, index) in n.lines">
                        <span v-text="line"></span>
                        <br />
                    </template>
                </div>
            </div>
            <div class="no-data" v-if="computedNotifications.length === 0">
                No notifications.
            </div>
            <!--<div class="see-all">See all notifications</div>-->
        </div>
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as NotificationTypes from "../constants/notification-types";
import * as Actions from "../store/constants/actions";

export default {
    name: "NotificationBox",
    data() {
        return {};
    },
    computed: {
        ...mapState(["notifications"]),
        computedNotifications() {
            return this.notifications.data.map((notification) => {
                let data = {
                    title: null,
                    text: null,
                    date: notification.created_at,
                    lines: []
                };
                switch (notification.type) {
                    case NotificationTypes.ORDER_STATUS_UPDATE:
                        data.title = "Order Status Update";
                        data.lines = [
                            "Order #: " + notification.data.order.id,
                            "Status: " +
                                this.$options.filters.capitalize_all(
                                    notification.data.order_status.status
                                )
                        ];
                        break;
                    case NotificationTypes.ORDER_CLOSED:
                        data.title = "Order Closed";
                        data.lines = [
                            "Order #: " +
                                notification.data.order.id +
                                " - has been closed"
                        ];
                        break;
                }
                return data;
            });
        }
    },
    mounted() {
        let fn = () => {
            this.$store.dispatch(Actions.FETCH_NOTIFICATIONS).then(() => {
                Vue.nextTick(() => {
                    window.Bus.$emit("updateScroller");
                });
                setTimeout(fn, 1000 * 60 * 15); // 15 minutes
            });
        };
        fn();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "sass:color";
@import "../../assets/scss/variables";

.notification-box {
    color: $text-color;

    .notify {
        margin-bottom: 20px;
        max-height: 70px;
        overflow: hidden;
        position: relative;

        /*&::after {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                width: 100%;
                height: 20px;
                box-shadow: 0px -20px 20px -10px $background-color inset;
            }*/

        .n-title {
            text-align: left;
            padding-right: 10px;
        }
        .n-desc {
            color: color.adjust($text-color, $alpha: -0.5);
        }

        &:hover {
            color: $text-color-accent;

            .n-desc {
                color: color.adjust($text-color-accent, $alpha: -0.5);
            }
        }
    }

    .see-all {
        &:hover {
            color: $text-color-accent;
        }
    }
}
</style>
